import { useMutation, useQuery } from '@tanstack/react-query';
import { getEntries, getEntry, updateEntry } from './entries.api';
import { IEntryProperty } from '../../common/interfaces/entry.interface';

export const useEntryQuery = (request_id: string, year_param: string, month_param: string) => {
  return useQuery({
    queryKey: ['entry', request_id, year_param, month_param],
    queryFn: () => getEntry(request_id, year_param, month_param),
    enabled: !!(request_id && year_param && month_param),
  });
};

export const useEntriesQuery = (request_id?: number) => {
  return useQuery({
    queryKey: ['entries', request_id],
    queryFn: () => getEntries(request_id),
    enabled: !!request_id,
  });
};

export const useUpdateEntryMutation = () => {
  return useMutation({
    mutationKey: ['entry', 'update'],
    mutationFn: ({
      entry_id,
      request_id,
      year,
      month,
      properties,
      details,
    }: {
      entry_id: number | undefined;
      request_id: number;
      year: number;
      month: number;
      properties: IEntryProperty[];
      details: string;
    }) => updateEntry(entry_id, request_id, year, month, properties, details),
  });
};
